(function () {
  'use strict';

  function initHCC() {
    // Only run on product pages
    var productForm = document.querySelector('[id^="product-form-"]');
    if (!productForm) return;

    // ── TRUST BADGES ──────────────────────────────────────────────────────────
    var buyBtns = document.querySelector('.product-form__buttons');
    if (buyBtns && !document.querySelector('.hcc-trust-badges')) {
      var badges = document.createElement('div');
      badges.className = 'hcc-trust-badges';
      badges.innerHTML =
        '<div class="hcc-trust-badge"><span class="hcc-trust-icon">✅</span><span>100% Authentic Products</span></div>' +
        '<div class="hcc-trust-badge"><span class="hcc-trust-icon">🚚</span><span>Free Shipping over €70</span></div>' +
        '<div class="hcc-trust-badge"><span class="hcc-trust-icon">💬</span><span>WhatsApp Expert Advice</span></div>' +
        '<div class="hcc-trust-badge"><span class="hcc-trust-icon">↩️</span><span>Easy Returns Policy</span></div>';
      buyBtns.insertAdjacentElement('afterend', badges);
    }

    // ── STICKY ATC BAR ────────────────────────────────────────────────
    if (document.getElementById('hcc-sticky-atc')) return;

    var titleEl = document.querySelector('.product__title h1, .product__title');
    var productTitle = titleEl ? titleEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.id = 'hcc-sticky-atc';
    bar.className = 'hcc-sticky-atc';
    bar.innerHTML =
      '<div class="hcc-sticky-atc__title">' + productTitle + '</div>' +
      '<div class="hcc-sticky-atc__price" id="hcc-sticky-price"></div>' +
      '<button class="hcc-sticky-atc__btn" id="hcc-sticky-btn">Add to cart</button>';
    document.body.appendChild(bar);

    var stickyBtn   = document.getElementById('hcc-sticky-btn');
    var stickyPrice = document.getElementById('hcc-sticky-price');

    function syncPrice() {
      var priceEl = document.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');
      if (priceEl && stickyPrice) {
        stickyPrice.textContent = priceEl.textContent.trim();
      }
    }
    syncPrice();

    var priceContainer = document.querySelector('.price');
    if (priceContainer) {
      new MutationObserver(syncPrice).observe(priceContainer, { subtree: true, childList: true, characterData: true });
    }

    function syncBtn() {
      var mainBtn = productForm.querySelector('[name="add"]');
      if (!mainBtn) return;
      stickyBtn.disabled = mainBtn.disabled;
      stickyBtn.textContent = mainBtn.disabled ? 'Sold out' : 'Add to cart';
    }
    syncBtn();

    var mainBtn = productForm.querySelector('[name="add"]');
    if (mainBtn) {
      new MutationObserver(syncBtn).observe(mainBtn, { attributes: true });
    }

    stickyBtn.addEventListener('click', function () {
      var btn = productForm.querySelector('[name="add"]');
      if (btn && !btn.disabled) btn.click();
    });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('hcc-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 }).observe(productForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHCC);
  } else {
    initHCC();
  }
})();
